import React from 'react';
import { useParams } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';

const ComingSoon = () => {
  const { module } = useParams();
  const [user, setUser] = React.useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  React.useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex h-screen bg-[#f0f2f5]">
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <div className={`flex-1 flex flex-col transition-all duration-300 ${
        isSidebarOpen ? 'md:ml-64' : 'md:ml-0'
      }`}>
        <Navbar user={user} toggleSidebar={toggleSidebar} />

        <main className="flex-1 flex items-center justify-center p-6" data-testid="coming-soon-page">
          <div className="text-center">
            <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-[#1a1a2e] mb-4 capitalize">
              {module || 'Module'}
            </h1>
            <p className="text-lg text-[#6b7280]">Coming Soon</p>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ComingSoon;